/**
 * API di produzione: il plugin in embed punta sempre qui.
 * In dev: window.CAMBIO_GOMME_CONFIG = { apiBaseUrl, gommistaId, container } per override.
 */
const PRODUCTION_API_BASE = 'https://api.cambiogomme-online.it/api'

export function getPluginConfig() {
  const globalConfig = typeof window !== 'undefined' && window.CAMBIO_GOMME_CONFIG
  if (globalConfig && globalConfig.apiBaseUrl && globalConfig.gommistaId) {
    return {
      apiBaseUrl: globalConfig.apiBaseUrl,
      gommistaId: String(globalConfig.gommistaId),
      container: globalConfig.container || '#cambio-gomme-widget',
      staticBaseUrl: globalConfig.staticBaseUrl || '',
    }
  }

  const scripts = document.getElementsByTagName('script')
  let src = ''
  for (let i = 0; i < scripts.length; i++) {
    const s = scripts[i].src
    if (s && (s.indexOf('plugin-cambio-gomme') !== -1 || s.indexOf('main.js') !== -1)) {
      src = s
      break
    }
  }
  if (!src) {
    console.error('[Plugin Cambio Gomme] Script tag non trovato.')
    return null
  }
  const urlParams = new URLSearchParams(src.split('?')[1] || '')
  const gommistaId = urlParams.get('gommista_id') || urlParams.get('id') || ''
  const container = '#cambio-gomme-widget'
  if (!gommistaId) {
    console.error('[Plugin Cambio Gomme] gommista_id mancante (es. ?gommista_id=123)')
    return null
  }
  const staticBaseUrl = (PRODUCTION_API_BASE || '').replace(/\/api\/?$/, '') || ''
  return {
    apiBaseUrl: PRODUCTION_API_BASE,
    gommistaId,
    container,
    staticBaseUrl,
  }
}
